import { ComponentPageWrapper } from 'pages/pages.styled'
import React, { useState } from 'react'
import { useEffect  } from 'react' 
import { useSelector, useDispatch } from 'react-redux'
import styled from 'styled-components' 
import toast, { Toaster } from 'react-hot-toast'; 
import { MobilePageTitle, pBtn } from 'components/main.styled'
import CreateButton from 'components/buttons/CreateButton'
import { setViewCreateQASessionModal, getQASessions } from 'features/qaSessions/qaSessionSlice'
import Modal from '@mui/material/Modal'; 
import CreateQASession from './CreateQASession'
import { useNavigate } from 'react-router-dom';
import TimeAgo from 'components/utils/LocalizedTimeAgo';
import { FaHourglassEnd } from "react-icons/fa";
import { CgLivePhoto } from "react-icons/cg";
import ExpirationTimer from 'components/utils/ExpirationTimer'
import SpinnerSmall from 'components/SpinnerSmall'
import SectionHelp from 'components/help/SectionHelp'
import { useTranslation } from 'react-i18next'


export default function QASessions() {
    const { t } = useTranslation('qna')
    const navigate = useNavigate()
    const dispatch = useDispatch() 
    const [qaSessionsFilter, setQASessionsFilter ] = useState("active")
    const { user, admin } = useSelector((state) => state.auth) 
    const { profileChurch } = useSelector((state) => state.profileChurch)   
    const { viewCreateQASessionModal, sessions, getQASessionsStatus }  = useSelector((state) => state.qASession)   
    
    const handleCreateQASession = () => {
        dispatch(setViewCreateQASessionModal(true))
    }

    useEffect(() => {
        dispatch(getQASessions({
            filter: qaSessionsFilter,
            churchId: profileChurch._id
        }))
    }, [])


    const handleNavigate = (session) => {

        // we can add the data to redux for faster load times and less potential server load similar to the way events are handled

        navigate(`/sessions/${session._id}`)       
    }

    const handleSessionStatusFilter = (value) => {

        setQASessionsFilter(value)

        dispatch(getQASessions({
            filter: value,
            churchId: profileChurch._id
        })) 
    }

    return (
        <ComponentPageWrapper>
            <Toaster /> 
            <MobilePageTitle>{t('title')}</MobilePageTitle>

            <QATop> 
                {(user.isOrganization || admin[profileChurch._id]) && (
                    <HeaderActions>
                        <CreateButton 
                            handler={() => handleCreateQASession(true)}
                            buttonText={'New Session'}
                            />
                        <SectionHelp
                            title={t('helpTitle')}
                            intro="Q&A sessions turn a sermon, class, meeting, or gathering into a moderated conversation."
                            options={[{
                                title: 'Create a Q&A session',
                                description: 'Members can submit questions during an active session while leaders control visibility, moderation, anonymity, and timing.',
                                bestFor: 'Sermon questions, Bible studies, town halls, classes, and live ministry conversations.',
                                features: ['Optional anonymous questions', 'Approval and moderation controls', 'Upvoting helps surface shared questions', 'Sessions can close automatically or manually'],
                            }]}
                            footer="Set expectations before the session begins so members understand whether questions are anonymous, moderated, or visible to others."
                            />
                    </HeaderActions>
                )} 
            </QATop>

            <Modal
                open={viewCreateQASessionModal}
                onClose={() => handleCreateQASession(false)}
                aria-labelledby="modal-modal-title"
                >
                <ModalWrapper1>    
                    <CreateQASession />
                </ModalWrapper1> 
            </Modal>

            <SessionsFeed>
                <TopBtnsWrap>
                    <QASessionsStatus
                        onClick={() => handleSessionStatusFilter("active")}
                        active={qaSessionsFilter === "active"}
                        >
                        <CgLivePhoto 
                            style={{color: qaSessionsFilter === "active" ? "green": "#ccc"}}
                            />
                        <span>Active</span>
                    </QASessionsStatus>
                    <QASessionsStatus
                        onClick={() => handleSessionStatusFilter("closed")}
                        active={qaSessionsFilter === "closed"}
                        >
                            < FaHourglassEnd />
                            <span>Closed</span>
                        
                    </QASessionsStatus>                    
                </TopBtnsWrap>


                {
                    getQASessionsStatus === "LOADING" ? 
                    (
                        <div style={{marginTop: "50px"}}>
                           <SpinnerSmall border='#5c5c5c' /> 
                        </div>
                        
                    )
                    :
                    (
                        
                        sessions.map((session) => (
                            <SessionItem
                                key={session._id}
                                onClick={()=>handleNavigate(session)}
                                >
                                <SessionTopWrap>
                                    <SessionTitleH1> { session.title  } </SessionTitleH1>
                                    <StatusTag 
                                        active={session.status === "active" ? true:false}
                                        >{session.status}</StatusTag>
                                </SessionTopWrap>

                                <SessionTopWrap>
                                    <SessionTitleH2>
                                        <TimeAgo datetime={new Date(session.createdAt)}/>
                                    </SessionTitleH2>
                                    {
                                        session.status === "active" && session.expiresAt && (
                                            <SessionTitleH2>
                                                <ExpirationTimer expiration={session.expiresAt}/>
                                            </SessionTitleH2>
                                        )
                                    }

                                </SessionTopWrap>
                            </SessionItem>
                        ))                            
                        
                    )

                } 
            </SessionsFeed>
        </ComponentPageWrapper> 
    )
}

const TopBtnsWrap = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    gap: 10px;
    margin-bottom: 16px;
`

const QASessionsStatus = styled(pBtn)`
    background-color: ${props => props.active ? "#eef9f1" : "#f2f6f8"};
    color: ${props => props.active ? "#168236" : "#626b70"};
    border: 1px solid ${props => props.active ? "#cdebd5" : "#e1e7eb"};
    border-radius: 7px;
    height: 36px;
    font-weight: 600;

    &:hover{
        background-color: ${props => props.active ? "#e6f6eb" : "#eef1f3"};
    }
`

const StatusTag = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 75px;
    font-size: 11px;
    height: 28px;
    border-radius: 6px;
    color: ${props => props.active ? "#168236":"#626b70"};
    background-color: ${props => props.active ? "#eef9f1":"#f2f6f8"};
    border: 1px solid ${props => props.active ? "#cdebd5":"#e1e7eb"};
    font-weight: 700;
    text-transform: capitalize;

`
 

const SessionsFeed = styled.div`
    width: 100%; 
    padding: 10px;
    display: flex;
    flex-direction: column;
`

const SessionTopWrap = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
` 

const SessionTitleH1 = styled.h1`
    font-size: 16px;
    color: var(--lightThemeFontColor);
    cursor: pointer;
    margin: 0;
    line-height: 1.35;
    font-weight: 700;
    
`

const SessionTitleH2 = styled.h2`
    font-weight: 500;
    font-size: 13px;
    color: #7b7f82;
    cursor: pointer;
    margin: 12px 0 0;
`

const SessionItem = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 18px;
    border-radius: 8px;
    transition: box-shadow 0.25s ease, transform 0.25s ease, border-color 0.25s ease;
    background-color: white;
    border: 1px solid #edf0f2;
    box-shadow: 0 4px 16px rgba(61, 70, 78, 0.10);
    margin-bottom: 14px;
    cursor: pointer;

    &:hover{
        border-color: #e0e7eb;
        box-shadow: 0 10px 24px rgba(61, 70, 78, 0.14);
        transform: translateY(-1px);
    }

    &:hover ${SessionTitleH1} {
        color: var(--themeColor);
    }
`

const ModalWrapper1 = styled.div`   
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

const QATop = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0px;   
    padding: 10px;


    @media (max-width: 768px) { 
        width: 100%;
        margin-bottom: 0px;
        
        /* margin-top: 10px; */
        align-items: center;
        justify-content: flex-start;
    }
`

const HeaderActions = styled.div`
    width: fit-content; display: flex; align-items: center; justify-content: flex-end; gap: 8px;
`
